import { Component, OnInit, NgZone } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ManikEntityService } from '../manik-library/ManikEntityService';
import { ProcessMicroSite } from './editing-microsite-base';
import { NovaBookingHandler } from '../NovaBooking/nova-booking-handler';
import { CookieManager } from '../manik-library/ManikEntityFE';
import { ManikEcommBase } from '../NovaEcomm/ManikEcommBase';
declare const window: any;
declare const $: any;
declare const grecaptcha: any;
import { SmartcardSiteBase } from './smartcard-site-base';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { EcommBase } from '../models/ecomm-base';

@Component({
  selector: 'app-smartcard-site',
  templateUrl: './smartcard-site.component.html',
  styleUrls: ['./smartcard-site.component.scss']
})
export class SmartcardSiteComponent extends SmartcardSiteBase implements OnInit {
  public oProcessMicroSite: ProcessMicroSite;
  public PreviewSite: string = "";
  private NovaBooking: NovaBookingHandler;
  SiteHtml: any;
  Interval: any;
  IsSiteLoadedInDOM: boolean = false;
  VisitorData: any = {};
  gRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';

  constructor(public httpClient: HttpClient, public _manikEntityService: ManikEntityService,
    public _routeParams: ActivatedRoute, private zone: NgZone, protected title: Title, public _dialog: MatDialog) {
    super(httpClient, _routeParams, title, _dialog);
    new EcommBase();
    this.oProcessMicroSite = new ProcessMicroSite(_manikEntityService);
    window.angularComponentRef = {
      zone: this.zone,
      componentFn: (value, action) => {
        this.SubmitEnquiryForm(value),
          this.BusinessID,
          this.PortalContext,
          this.BizHandle,
          this.PortalDS,
          this.BackendURL,
          this.StoreHandle,
          this.ManageCart(value, action),
          this.Local_EventOnFilterChange(value, action),
          this.PopulateProductDetails(value),
          this.BookResource(value),
          this.OnDemandDivArray,
          this.HandleBookingCalendar(value, action),
          this.DrawBookingSupportingEffect(value),
          this.Checkout(),
          this.ProductList,
          this.VarientList,
          this.oProcessMicroSite
      },
      component: this
    };
    this.populateControls();
    this.NovaBooking = new NovaBookingHandler(_manikEntityService, this.document);
  }

  ngOnInit() {
    this.PreviewSite = location.origin + "/" + this._routeParams.snapshot.params['businessslug'];
    this.Interval = setInterval(() => {
      this.SiteHtml = this.SiteMetaData;
      if (this.IsWebPageInitialized) {
        clearInterval(this.Interval);
        // setTimeout(() => {
          this.IsSiteLoadedInDOM = true;
          if (this.IsSmartSite) this.gRecaptcha = grecaptcha.render('iManikgreCaptchaDiv', {
            'sitekey': '6Le3BbkUAAAAAGNMzPm4nEe-hm1W2HB6PQe8YFD3'//Try keeping this in environment.ts
          });
        // }, 10);
      }
    }, 10);

  }

  SubmitEnquiryForm(Body: any) {
    let x = grecaptcha.getResponse(this.gRecaptcha);
    this.CaptchaInvalid = false;
    this.CaptchaMessage = '';
    this._manikEntityService.manikEntityConnect2('WebSite/captcha/v2?sToken=' + x, null, null)
      .subscribe(data => {
        if (data.success) {
          let body = {};
          let IP = "";
          this._manikEntityService.manikGetMyIPAddress()
            .subscribe(IP => {
              body["BusinessHandle"] = this.WebSiteMetaData["BizHandle"];
              body["IPAddress"] = IP;
              this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", JSON.stringify({ "items": [body] }), this.prepareManageHeaders2("A", "BUSINESS.ENQUIRY", "BIZ"))
                .subscribe(data => {
                  let resp: any = data;
                  Body.forEach(item => {
                    item["EnquiryID"] = resp.ManikJSon[0].JSon0[0].NewEntity;
                  });
                  this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", JSON.stringify({ "items": Body }), this.prepareManageHeaders2("A", "BUSINESS.ENQUIRYDATA", "BIZ"))
                    .subscribe(response => {
                      let d = response;
                      alert('Request has been submitted !!!')
                    });
                });
            });
        }
        else {

        }
      });

  }

  PublishMicrosite() {
    this.oProcessMicroSite.Interval = setInterval(() => {
      if (this.oProcessMicroSite.ProcessingText === "Processing...") {
        this.oProcessMicroSite.ProcessingText = "Processing.";
      }
      else if (this.oProcessMicroSite.ProcessingText === "Processing..") {
        this.oProcessMicroSite.ProcessingText = "Processing...";
      }
      else if (this.oProcessMicroSite.ProcessingText === "Processing.") {
        this.oProcessMicroSite.ProcessingText = "Processing..";
      }
    }, 300);
    this.oProcessMicroSite.IsProcessing = true;
    this.oProcessMicroSite.PublishMicroSite(this._routeParams.snapshot.params['businessslug'], this.PortalContext);
  }

  ResetBackgrounds(): void {
    this.oProcessMicroSite.ResetBackgrounds(this._routeParams.snapshot.params['businessslug'], this.PortalContext);
  }

  ManageCart(product, action): void {
    this.NovaEcomm = new ManikEcommBase(this.httpClient);
    switch (action) {
      case "A":
        this.NovaEcomm.Local_CartSmartManagePlus(product);
        break;
      case "R":
        this.NovaEcomm.Local_CartSmartManageMinus(product, action);
        break;
      case "D":
        this.NovaEcomm.Local_CartSmartManageMinus(product, action);
        break;
      default:
         this.NovaEcomm.Local_Cart_View();
        break;
    }
  }

  SelectSummaryDiv(source) {
    $('#iManikEcommSummary').hide();
    $('#iManikBookingSummary').hide();
    switch (source) {
      case 'ECOMM':
        $('#iManikEcommSummary').show();
        break;
      case 'BOOKING':
        $('#iManikBookingSummary').show();
        break;
    }
  }

  PopulateProductDetails(ProductHandle: string) {
    //this.NovaEcomm.PopulateProductDetails(this.StoreHandle, ProductHandle);
  }

  Local_EventOnFilterChange(CategoryID: string = "", Type: string = "") {
    this.NovaEcomm.Local_EventOnFilterChange(this.StoreHandle, CategoryID, Type);
  }

  public PatymPayments(): void {
    this._manikEntityService.manikWebAPIConnect("WebSite/Paytm/initializepayment", null, null).
      subscribe(data => {
        //console.log(data);
      });
    // this._manikEntityService.manikEntityConnect2("WebSite/Paytm", null, null)
    //   .subscribe(data => {
    //     this.SiteHtml = data.Response;
    //     setTimeout(() => {
    //       this.document.f1.submit();
    //     }, 50);
    //     //this.SiteMetaData = data.Response;
    //     console.log(data);
    //   });
  }

  Checkout() {
    this.NovaEcomm.API_Checkout();
  }

  BookResource(PostedData: any) {
    PostedData["BuyerHandle"] = JSON.parse(sessionStorage.getItem("UserData")).BuyerHandle;
    this.BookingStore.SubmitBookingRequest(PostedData);
  }

  HandleBookingCalendar(val, action) {
    switch (action) {
      case 'NEXT':
        this.NovaBooking.OnClickNext();
        break;
      case 'PREV':
        this.NovaBooking.OnClickPrevious();
        break;
      case 'DATE':
        this.NovaBooking.OnClickDate(val[0]);
        break;
      case 'SLOT':
        if (val) this.NovaBooking.OnClickSlot(val[0], val[1]);
        break;
    }
  }

  DrawBookingSupportingEffect(val) {
    this.NovaBooking.DrawSupportingEffect(val);
  }

  VisitorLoggedIn() {
    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      this.VisitorData = x;
      // console.log(x);
    }
  }
}